import en from '@/messages/en.json';
import es from '@/messages/es.json';
import type { Locale } from './locales';

export type Messages = typeof es;

export const messagesByLocale: Record<Locale, Messages> = {
  es,
  en,
};
